import React from 'react';
import {getPrice} from "../util/price";

class BookingUpsellService extends React.PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            expanded: false,
            totalPrice: this.getTotalItemPrice(props.price.value, props.extras),
            totalSalesPrice: this.getTotalItemPrice((props.salesPrice && props.salesPrice.value) || 0, props.extras)
        }
    }

    componentDidUpdate() {
        this.setState({
            ...this.state,
            totalPrice: this.getTotalItemPrice(this.props.price.value, this.props.extras),
            totalSalesPrice: this.getTotalItemPrice((this.props.salesPrice && this.props.salesPrice.value) || 0, this.props.extras)
        })
    }

    getTotalItemPrice(price, extras = []) {
        let totalPrice = parseFloat(price);
        extras.forEach(extra => {
            if (extra.checked) {
                totalPrice += parseFloat(extra.price);
            }
        });
        return getPrice(totalPrice);
    }

    toggleExpand() {
        this.setState(prevState => ({
            expanded: !prevState.expanded
        }));
    }

    extraChangeHandler(e, extra) {
        this.props.extraChangeHandler(e.target.checked, this.props.id, extra);
    }

    renderExtras() {
        return this.props.extras.map((item, index) => {
            return (
                <label key={index} className="checkbox">
                    <span className="checkbox__title">
                        {item.title} <span className="booking-service__extra">
                            {trans.currency_prepend}{item.price}{trans.extra_append}</span>
                    </span>
                    <input type="checkbox" defaultChecked={item.checked} onChange={(e) => this.extraChangeHandler(e, item)}/>
                    <span className="checkmark" />
                </label>
            );
        });
    }


    getPriceElement() {
        if (this.props.isOnSale) {
            return (
                <>
                    <div className="text-fifth-red">
                        <span className="booking-service__price">{this.state.totalSalesPrice} </span>
                        {this.props.price.append}
                    </div>
                    <div className="text-xs line-through">
                        <span className="booking-service__price">{this.state.totalPrice} </span>
                        {this.props.price.append}
                    </div>
                </>
            );
        } else {
            return (
                <span className="booking-service__price">{this.state.totalPrice} {this.props.price.append}</span>
            );
        }
    }

    render() {
        return (
            <div className="booking-service react-collapse-item w-full">
                <div className=" react-collapse-header flex flex-wrap justify-between items-center react-collapse-toggle" onClick={() => this.toggleExpand()}>
                    <div className="flex-1 flex flex-col md:flex-row">
                        <h3 className="booking-service__title flex-1 flex items-center">
                            {this.props.title}
                            { this.props.extras.length || this.props.description.length
                                ? <a className="md:hidden service-item__more"><i className="fas fa-angle-down" /></a>
                                : null }

                            { this.props.extras.length || this.props.description.length
                            ?  <a className="hidden md:inline-block service-item__more">read more</a>
                            : null}
                        </h3>
                        <ul className="booking-service__details flex items-center md:text-right">
                            {
                                this.props.duration.value
                                ? <li><span className="booking-service__duration">{this.props.duration.value}{this.props.duration.append}</span></li>
                                : null
                            }

                            <li>
                                {this.getPriceElement()}
                            </li>
                        </ul>
                    </div>
                    <div className="flex items-center justify-center btn btn-red ml-4" onClick={this.props.addItem}><span><i className={'fas inline-block fa-plus'} /></span></div>
                </div>
                { this.props.extras.length || this.props.description.length ?
                    <div className={"react-collapse-content " + (this.state.expanded ? "expanded" : "")}>
                        <div className="react-collapse-content-inner">
                            <div className="booking-service__description" dangerouslySetInnerHTML={{__html: this.props.description}}>

                            </div>
                            <div className="booking-service__options">
                                { this.renderExtras() }
                            </div>
                        </div>
                    </div> : null
                }
            </div>
        )
    }
}

export default BookingUpsellService;



// WEBPACK FOOTER //
// ./scripts/components/BookingUpsellService.jsx